import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InfoCocktailModalComponent } from './components/info-cocktail-modal/info-cocktail-modal.component';
import { LogoComponent } from './components/logo/logo.component';
import { BigImageComponent } from './components/big-image/big-image.component';
import { FooterComponent } from './components/footer/footer.component';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { MapComponent } from './components/map/map.component';
import { PiantinaComponent } from './components/piantina/piantina.component';
import { PinchZoomModule } from 'ngx-pinch-zoom';
import { MaterialModule } from './material/material.module';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { LoginCodeComponent } from '../local-name/pre-booking/login-code/login-code.component';
import { QRCodeModule } from 'angular2-qrcode';


@NgModule({
  declarations: [
    InfoCocktailModalComponent,
    LogoComponent,
    BigImageComponent,
    FooterComponent,
    MapComponent,
    PiantinaComponent,
    ToolbarComponent,
    LoginCodeComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    LeafletModule,
    PinchZoomModule,
    MaterialModule,
    QRCodeModule
  ],
  exports: [
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    LeafletModule,
    PinchZoomModule,
    MaterialModule,
    QRCodeModule,

    InfoCocktailModalComponent,
    LogoComponent,
    BigImageComponent,
    FooterComponent,
    MapComponent,
    PiantinaComponent,
    ToolbarComponent,
    LoginCodeComponent
  ]
})
export class SharedModule {
}
